export const FEATURE_GATE_URL_DICTIONARY = {
  customFields: {
    revshare: {
      url: '/rs-custom-fields',
      popUpCopy: '{{featureName}} is a Premium feature',
      buttonCta: 'Learn More',
    },
    channel: {
      url: '/ch-custom-fields',
      popUpCopy: '{{featureName}} is a Premium feature',
      buttonCta: 'Learn More',
    },
  },
  occupancyReport: {
    revshare: {
      url: '/rs-occupancy-reports',
      popUpCopy: '{{featureName}} is a Premium feature',
      buttonCta: 'Learn More',
    },
    channel: {
      url: '/ch-occupancy-reports',
      popUpCopy: '{{featureName}} is a Premium feature',
      buttonCta: 'Learn More',
    },
  },
  basicRulesEngine: {
    revshare: {
      url: '/rs-rules-engine',
      popUpCopy: '{{featureName}} is a Premium feature',
      buttonCta: 'Learn More',
    },
    channel: {
      url: '/ch-rules-engine',
      popUpCopy: '{{featureName}} is a Premium feature',
      buttonCta: 'Learn More',
    },
  },
  granularPermissions: {
    revshare: {
      url: '/rs-granular-permissions',
      popUpCopy: '{{featureName}} is a Premium feature',
      buttonCta: 'Learn More',
    },
    channel: {
      url: '/ch-granular-permissions',
      popUpCopy: '{{featureName}} is a Premium feature',
      buttonCta: 'Learn More',
    },
  },
  lockdown: {
    revshare: {
      url: '/rs-flexible-lockdown',
      popUpCopy: '{{featureName}} is a Premium feature',
      buttonCta: 'Learn More',
    },
    channel: {
      url: '/ch-flexible-lockdown',
      popUpCopy: '{{featureName}} is a Premium feature',
      buttonCta: 'Learn More',
    },
  },
  azureIdentityProvider: {
    revshare: {
      url: '/rs-essential-user-management',
      popUpCopy: '{{featureName}} is a Premium feature',
      buttonCta: 'Learn More',
    },
    channel: {
      url: '/ch-essential-user-management',
      popUpCopy: '{{featureName}} is a Premium feature',
      buttonCta: 'Learn More',
    },
  },
  gsuiteIdentityProvider: {
    revshare: {
      url: '/rs-essential-user-management',
      popUpCopy: '{{featureName}} is a Premium feature',
      buttonCta: 'Learn More',
    },
    channel: {
      url: '/ch-essential-user-management',
      popUpCopy: '{{featureName}} is a Premium feature',
      buttonCta: 'Learn More',
    },
  },
  oktaIdentityProvider: {
    revshare: {
      url: '/rs-premier-user-management',
      popUpCopy: '{{featureName}} is a Premium feature',
      buttonCta: 'Learn More',
    },
    channel: {
      url: '/ch-premier-user-management',
      popUpCopy: '{{featureName}} is a Premium feature',
      buttonCta: 'Learn More',
    },
  },
  oneloginIdentityProvider: {
    revshare: {
      url: '/rs-premier-user-management',
      popUpCopy: '{{featureName}} is a Premium feature',
      buttonCta: 'Learn More',
    },
    channel: {
      url: 'h/ch-premier-user-management',
      popUpCopy: '{{featureName}} is a Premium feature',
      buttonCta: 'Learn More',
    },
  },
  occupancyManagement: {
    revshare: {
      url: '/rs-occupancy-management',
      popUpCopy: '{{featureName}} is a Premium feature',
      buttonCta: 'Learn More',
    },
    channel: {
      url: '/ch-occupancy-management',
      popUpCopy: '{{featureName}} is a Premium feature',
      buttonCta: 'Learn More',
    },
  },
  vms: {
    revshare: {
      url: '/rs-milestone-integration',
      popUpCopy: '{{featureName}} is a Premium feature',
      buttonCta: 'Learn More',
    },
    channel: {
      url: '/ch-milestone-integration',
      popUpCopy: '{{featureName}} is a Premium feature',
      buttonCta: 'Learn More',
    },
  },
  merakiVms: {
    revshare: {
      url: '/rs-meraki-integration',
      popUpCopy: '{{featureName}} is a Premium feature',
      buttonCta: 'Learn More',
    },
    channel: {
      url: '/ch-meraki-integration',
      popUpCopy: '{{featureName}} is a Premium feature',
      buttonCta: 'Learn More',
    },
  },
  customDashboards: {
    revshare: {
      url: '/rs-custom-dashboards',
      popUpCopy: '',
      buttonCta: '',
    },
    channel: {
      url: '/ch-custom-dashboards',
      popUpCopy: '',
      buttonCta: '',
    },
  },
  allegionNdebLeb: {
    revshare: {
      url: '/rs-allegion-ndebleb-integration',
      popUpCopy: '',
      buttonCta: '',
    },
    channel: {
      url: '/ch-custom-dashboards',
      popUpCopy: '',
      buttonCta: '',
    },
  },
  voiceAssistant: {
    revshare: {
      url: '',
      popUpCopy: '{{featureName}} app is required',
      buttonCta: 'Install app',
    },
    channel: {
      url: '',
      popUpCopy: '{{featureName}} app is required',
      buttonCta: 'Install app',
    },
  },
  musterReport: {
    revshare: {
      url: '/rs-premium-feature',
      popUpCopy: '{{featureName}} app is required',
      buttonCta: 'Install app',
    },
    channel: {
      url: '/ch-premium-feature',
      popUpCopy: '{{featureName}} app is required',
      buttonCta: 'Install app',
    },
  },
  alarmManagement: {
    revshare: {
      url: '/rs-premium-feature',
      popUpCopy: '{{featureName}} app is required',
      buttonCta: 'Install app',
    },
    channel: {
      url: '/ch-premium-feature',
      popUpCopy: '{{featureName}} app is required',
      buttonCta: 'Install app',
    },
  },
  samlSso: {
    revshare: {
      url: '/rs-premium-feature',
      popUpCopy: '{{featureName}} app is required',
      buttonCta: 'Install app',
    },
    channel: {
      url: '/ch-premium-feature',
      popUpCopy: '{{featureName}} app is required',
      buttonCta: 'Install app',
    },
  },
  generic: {
    revshare: {
      url: '/rs-premium-feature',
      popUpCopy: '{{featureName}} is a Premium feature',
      buttonCta: 'Learn More',
    },
    channel: {
      url: '/ch-premium-feature',
      popUpCopy: '{{featureName}} is a Premium feature',
      buttonCta: 'Learn More',
    },
  },
};
